<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-input
        v-model="query.name"
        placeholder="名称"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button type="primary" size="small" @click="_modify(null)">添加</el-button>
    </div>
    <div style="flex: auto;">
      <el-table v-loading="loading" :data="tableData" height="100%">
        <el-table-column prop="fDw" label="单位名称" />
        <el-table-column prop="fShNumber" label="社会统一信用代码" />
        <el-table-column prop="fAddress" label="地址" />
        <el-table-column prop="fPhone" label="电话" />
        <el-table-column prop="fBankName" label="开户行名称" />
        <el-table-column prop="fBankNumber" label="开户行账号" />
        <el-table-column prop="fAddress_fp" label="发票邮寄地址" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_modify(scope.row)">查看</el-button>
            </template>
            <template>
              <ConfirmButton @confirm="_delete(scope.row)">删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import EditForm from './EditForm'
import { Today } from '@assets/site'
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    EditForm,
    ConfirmButton
  },
  data() {
    return {
      query: {
        name: null
      },
      tableData: [],
      loading: false,
      currentEditItem: null
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('BusinessManage/Invoice/InvoiceEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist
        })
        .finally(() => (this.loading = false))
    },

    _modify: async function(row) {
      const isNew = !row
      if (isNew) {
        this.currentEditItem = {}
      } else {
        this.currentEditItem = Object.assign({}, row)
      }
      const h = this.$createElement
      this.$formDlg({
        title: isNew ? `新增客户` : '查看客户',
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData),
        width: '50%'
      })
    },
    postData(modifyType, data) {
      return this.$httpPost(`BusinessManage/Invoice/InvoiceModify`, {
        datalist: JSON.stringify({ modifyType: modifyType, info: data })
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    _delete(row) {
      this.loading = true
      this.$httpPost(`BusinessManage/Invoice/InvoiceDelete`, {
        fid: row.fid
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

